import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchQRCodes, createQRCode } from "./thunk";

interface QRCodeRecord {
  id: string;
  name?: string;
  description?: string;
  qr_type: string;
  payload: Record<string, any>;
  track_scans: boolean;
  remove_watermark: boolean;
  scan_count: number;
  created_at?: string;
  updated_at?: string;
}

interface QRGeneratorState {
  codes: QRCodeRecord[];
  loading: boolean;
  error: string | null;
  creating: boolean;
  createError: string | null;
}

const initialState: QRGeneratorState = {
  codes: [],
  loading: false,
  error: null,
  creating: false,
  createError: null,
};

const qrGeneratorSlice = createSlice({
  name: "qrGenerator",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQRCodes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQRCodes.fulfilled, (state, action: PayloadAction<QRCodeRecord[]>) => {
        state.loading = false;
        state.codes = action.payload || [];
      })
      .addCase(fetchQRCodes.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed to load QR codes";
      })
      .addCase(createQRCode.pending, (state) => {
        state.creating = true;
        state.createError = null;
      })
      .addCase(createQRCode.fulfilled, (state, action: PayloadAction<QRCodeRecord | undefined>) => {
        state.creating = false;
        if (action.payload) {
          state.codes = [action.payload, ...state.codes];
        }
      })
      .addCase(createQRCode.rejected, (state, action) => {
        state.creating = false;
        state.createError = (action.payload as string) || "Failed to save QR code";
      });
  },
});

export default qrGeneratorSlice.reducer;

